import { AlignmentFilterCriterion } from './alignmentModalFilters.helpers';

const ALIGNMENT_MODAL_FILTERS_KEY = 'alignment-modal-filters';

export const getFilterStorageKey = (
  orgId: string | number | undefined,
  userId: string | number | undefined,
  objectiveId: string | number | undefined,
): string | null => {
  if (!orgId || !userId || !objectiveId) {
    return null;
  }
  return `${ALIGNMENT_MODAL_FILTERS_KEY}-${orgId}-${userId}-${objectiveId}`;
};

export const loadFilterCriteria = (key: string | null): AlignmentFilterCriterion[] | null => {
  if (!key) {
    return null;
  }
  try {
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.length ? parsed : null;
  } catch {
    return null;
  }
};

export const saveFilterCriteria = (
  key: string | null,
  criteria: AlignmentFilterCriterion[],
): void => {
  if (!key) {
    return;
  }
  try {
    localStorage.setItem(key, JSON.stringify(criteria));
  } catch {
    // storage unavailable or over quota — persistence is best-effort
  }
};
